<script>
import Plugins from '@/helpers/Plugins'

let componentsCache = new Map()

export default {
    name: 'oc-advanced',
    functional: true,
    props: {
        $name: {
            type: String,
            required: true
        },
        /**
         * If you call two exact same component with different props under same parent,
         * then you will need to provide unique $id in order not to cache the first and use it for both.
         */
        $id: {
            type: [String, Number]
        },
        $disableCache: {
            type: Boolean,
            default: false
        },
        $load: {
            type: [String, Array],
            required: true
        },
        $source: {
            type: String
        },
        $modelProp: {
            type: String,
            default: 'data'
        },
        $modelEvent: {
            type: String,
            default: 'input'
        },
        // for oc-advanced v-model
        // this will prevent the data to be presented as dom attribute on the first child element
        value: {
            default: null
        }
    },
    render(createElement, context) {
        // ----------------------------------------------------
        function loadProcessed() {
            if( typeOf(context.props.$load) === 'string' ) {
                if( context.props.$load.trim().length === 0 ) {
                    return []
                }

                return context.props.$load.split(',').map(x => x.trim()).filter(x => x !== '')
            }

            return context.props.$load
        }

        let loadedPlugins = loadProcessed()

        function loadPluginsHandler() {
            let source = context.props.$source
            let name = context.props.$name

            let sourceMap = {
                "oc-table" : "ui/table",
                "oc-tree" : "ui/tree"
            }

            if( source === undefined && inArray(name, Object.keys(sourceMap)) ) {
                source = sourceMap[name]
            }

            let pluginSourcePath = source !== undefined
                ? source // custom source path
                : name   // real component name

            return new Plugins(loadedPlugins, pluginSourcePath)
        }
        // ----------------------------------------------------

        let pluginsHandler = loadPluginsHandler()

        let cacheKey = context.parent.$vnode.tag + '.' + context.parent._uid + '.' + context.props.$name + '.' + context.props.$id

        let advanced
        if( false === context.props.$disableCache && componentsCache.has(cacheKey) ) {
            advanced = componentsCache.get(cacheKey)
        } else {
            advanced = Vue.component(context.props.$name).extend({
                mixins: pluginsHandler.getMixins(),
                model: {
                    prop: context.props.$modelProp,
                    event: context.props.$modelEvent
                },
                provide() {
                    return {
                        $plugins: this.$plugins,
                        $source: this
                    }
                },
                computed: {
                    $plugins() {
                        return pluginsHandler
                    }
                }
            })

            if( false === context.props.$disableCache ) {
                componentsCache.set(cacheKey, advanced)
            }
        }

        let data = Object.assign(
            {},
            context.data,
            {
                scopedSlots: context.scopedSlots,
                slots: context.slots,
                on: context.listeners
            }
        )

        if( data.attrs === undefined ) {
            data.attrs = {}
        }

        return createElement(
            advanced,
            data,
            context.children
        )
    }
}
</script>
